import React from 'react';
import { isMobile } from 'react-device-detect';
import { useIsMobileDimensions } from '../_puzzles/shared/utils';
import { useNavigate } from 'react-router-dom';
// import { FaDiscord as DiscordLogo } from 'react-icons/fa';
import './Footer.less';

const Footer = ({ keepMobileFooter }: { keepMobileFooter?: boolean }) => {
  const navigate = useNavigate();
  const isMobileDimensions = useIsMobileDimensions();
  if ((isMobile || isMobileDimensions) && !keepMobileFooter) return null;

  return (
    <footer className="footer">
      <hr/>
      <ul>
        <li>
          <div className="footerItemTitle">About</div>
          <div className="footerItemContent">
            The Daily Baffle is a digital endeavour aiming to bring entirely new word and logic puzzles to the teeming masses. We hope you enjoy.
          </div>
        </li>
        <li>
          <div className="footerItemTitle">Discord</div>
          <div className="footerItemContent">
            <a href="https://discord.gg/Ar9hENwrUQ" target="_blank">
             Join us on Discord!
            </a>
          </div>
        </li>
        <li>
          <div className="footerItemTitle">Contact</div>
          <div className="footerItemContent">
            Please direct questions, concerns, threats, and feedback to <a target="_blank" href="mailto:editor@dailybaffle.com">editor@dailybaffle.com</a>.
          </div>
        </li>
        <li>
          <div className="footerItemTitle">Morphology Submissions</div>
          <div className="footerItemContent">
            Read more <a target="_blank" href="/submissions">here</a>.
          </div>
        </li>
        <li>
          <ul className="footerItemTitle bottomItems">
            <li>
              <a target="_blank" href="https://www.termsfeed.com/live/685896b5-d881-40b3-abda-44709050cd37">Privacy Policy</a>
            </li>
            <li>
              <span className="copyright">© 2025 The Daily Baffle</span>
            </li>
            <li>
              <a onClick={() => {
                navigate('/about');
                window.scrollTo(0, 0);
              }} className="aboutLink">About+</a>
            </li>
          </ul>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;